import { useNavigate } from 'react-router-dom'

import { Avatar, Badge, Box, Stack, Typography } from '@mui/material'
import { Paper } from 'oneui'
import { EllipsisStyle, SummaryPaperStyle } from 'styles/theme/theme'
import { EVENT_KEYS } from 'utils/constants'
import { isCJK, isFamilyNameOrderFirst } from 'utils/i18n'

import { ProfileCardProps } from '..'
import IconAlert from '../../assets/images/alert.svg'

const defaultPhotoUrl = '/assets/images/profile/default-profile.svg'

const SmallProfileCard = ({ profile }: { profile: ProfileCardProps }) => {
  const navigate = useNavigate()

  const handleDashboardProfile = () => {
    navigate('/dashboard/profile')
  }

  return (
    <Box
      tabIndex={0}
      onClick={handleDashboardProfile}
      onKeyDown={(event) => {
        if (event.key === EVENT_KEYS.SPACE || event.key === EVENT_KEYS.ENTER) {
          event.preventDefault()
          handleDashboardProfile()
        }
      }}
      sx={{ cursor: 'pointer' }}
      data-testid='Box9E09C45A'
    >
      <Paper
        sx={{
          ...SummaryPaperStyle,
          height: { xs: '198px', md: '192px' },
          padding: { xs: '30px', md: '26px' },
          marginBottom: '16px'
        }}
      >
        <Stack justifyContent='center' alignItems='center' sx={{ height: '100%', textAlign: 'center', width: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '66px', width: '100%' }}>
            {profile.isShowBadge ? (
              <Badge
                overlap='circular'
                badgeContent={<Box component='img' src={IconAlert} alt='' />}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
              >
                <Avatar sx={{ height: '66px', width: '66px' }} src={profile.photoUrl || defaultPhotoUrl} />
              </Badge>
            ) : (
              <Avatar sx={{ height: '66px', width: '66px' }} src={profile.photoUrl || defaultPhotoUrl} />
            )}{' '}
          </Box>
          <Box sx={{ marginTop: '20px', ...EllipsisStyle }}>
            <Typography sx={{ fontSize: { xs: '25px', md: '24px' }, lineHeight: { xs: '32px', md: '28px' } }}>
              {isCJK(profile.givenName + profile.familyName)
                ? `${profile.familyName}${profile.givenName}`
                : isFamilyNameOrderFirst()
                ? `${profile.familyName} ${profile.givenName}`
                : `${profile.givenName} ${profile.familyName}`}
            </Typography>
          </Box>
          <Box sx={{ mt: { xs: '0px', md: '4px' }, ...EllipsisStyle }}>
            <Typography
              sx={{
                fontSize: { xs: '15px', md: '16px' },
                lineHeight: { xs: '20px', md: '22px' },
                fontWeight: '400'
              }}
            >
              {profile.loginId}
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Box>
  )
}

export default SmallProfileCard
